import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 80,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};
const options = [
  { label: "AM", value: "am" },
  { label: "PM", value: "pm" },
];
const DateTimePicker = ({ onTimeChange, time }) => {
  const [startDate, setStartDate] = useState(moment(time).toDate());
  const [startHour, setStartHour] = useState(moment(time).toDate().getHours() % 12);
  const [startMinute, setStartMinute] = useState(moment(time).toDate().getMinutes());
  const [ap, setAP] = useState(moment(time).toDate().getHours() < 12 ? options[0] : options[1]);
  useEffect(() => {
    onTimeChange(calculateTime());
  }, [startDate, startHour, startMinute, ap]);

  useEffect(() => {
    if (time) {
      console.log("date", moment(time).toDate());
      setStartDate(moment(time).toDate());
      setStartHour(moment(time).toDate().getHours() % 12);
      setStartMinute(moment(time).toDate().getMinutes());
      setAP(moment(time).toDate().getHours() < 12 ? options[0] : options[1]);
    }
  }, [time]);

  function onChangeHandler(e) {
    if (e.target.name === "hh") setStartHour(parseInt(e.target.value));
    else setStartMinute(parseInt(e.target.value));
  }
  function handleSelectChange(option) {
    setAP(option);
  }
  function calculateTime() {
    let date_time = new Date(startDate);
    let hours = startHour;
    if (ap.value === "pm" && startHour !== 12) hours = startHour + 12;
    date_time.setHours(hours);
    date_time.setMinutes(startMinute);
    date_time.setSeconds(0);
    date_time.setMilliseconds(0);
    return moment(date_time);
  }
  return (
    <div className="form-group date_time_picker">
      <p className="title">Select Date</p>
      <DatePicker
        selected={startDate}
        onChange={(date) => setStartDate(date)}
      />
      <p className="title">Select Time</p>
      <div className="time-div">
        <input
          className="form-control"
          type="number"
          placeholder="00"
          name="hh"
          max="12"
          min="0"
          value={startHour}
          onChange={onChangeHandler}
        />
        &nbsp;:&nbsp;
        <input
          className="form-control"
          type="number"
          placeholder="00"
          name="mm"
          max="59"
          min="0"
          value={startMinute}
          onChange={onChangeHandler}
        />
        &nbsp;&nbsp;&nbsp;
        <Select
          value={ap}
          onChange={handleSelectChange}
          options={options}
          styles={Styles}
        />
      </div>
    </div>
  );
};

export default DateTimePicker;



// WEBPACK FOOTER //
// ./src/components/DateTimePicker/index.js